export function formatValue(decimal) {
  var precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var locale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : void 0;
  var decimalPrecision = precision.decimalPrecision,
    significantDigits = precision.significantDigits;
  if (parseInt(decimalPrecision) >= 0) return decimal.toFixed(decimalPrecision, locale);
  if (parseInt(significantDigits) >= 1) return decimal.toPrecision(significantDigits, locale);
  return locale ? decimal.toLocaleString(locale) : decimal.toString();
}
export default formatValue;